import { render, staticRenderFns } from "./UserProfiles.vue?vue&type=template&id=7c281949&scoped=true"
import script from "./UserProfiles.vue?vue&type=script&lang=js"
export * from "./UserProfiles.vue?vue&type=script&lang=js"
import style0 from "./UserProfiles.vue?vue&type=style&index=0&id=7c281949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c281949",
  null
  
)

export default component.exports